/**
 * The Study Build banner's wording. Pure, so it can be tested.
 *
 * The data dictionary's stored form count is a dictionary number (spelling
 * variants of a form's name can inflate it), so it is never labelled
 * "approved". The approved count is the CRF Builder's: forms with status
 * approved or final.
 */
export interface EdcBannerText {
  /** The one-sentence summary. */
  summary: string;
  /** More forms are approved than the dictionary covers: it needs regenerating. */
  stale: boolean;
}

export function edcBuildBannerText(
  dd: { formCount: number; fieldCount: number },
  crf: { total: number; approved: number } | null,
): EdcBannerText {
  const forms = (n: number) => `${n} ${n === 1 ? 'form' : 'forms'}`;
  const fields = dd.fieldCount > 0 ? ` (${dd.fieldCount} fields)` : '';
  const covers = `The Data Dictionary currently covers ${forms(dd.formCount)}${fields}`;
  if (!crf) return { summary: `${covers}.`, stale: false };
  const stale = crf.approved > dd.formCount;
  return {
    summary:
      `${covers}; ${crf.approved} of ${crf.total} case report ${crf.total === 1 ? 'form is' : 'forms are'} approved in the CRF Builder.`,
    stale,
  };
}
